/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <div v-if="!code">
      <!-- 面包屑导航 -->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb> -->
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="">
          <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="addVisible = true">添加锁仓</el-button>
        </el-form-item>

      </el-form>
      <!--列表-->
      <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <!-- normal:普通用户,holder矿机主，primary股东，partner 合伙人 -->
        <!-- <el-table-column align="center" prop="userType" label="身份类型" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.userType == 'normal'">普通用户</div>
            <div v-if="scope.row.userType == 'holder'">矿机主</div>
            <div v-if="scope.row.userType == 'primary'">股东</div>
            <div v-if="scope.row.userType == 'partner'">合伙人</div>
          </template>
        </el-table-column> -->
        <el-table-column align="center" prop="userName" label="用户名" width="300">
        </el-table-column>
        
        <!-- <el-table-column align="center" prop="userType" label="用户类型" width="300">
        </el-table-column> -->
        <el-table-column align="center" label="用户类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.userType == 'normal'">普通用户</div>
            <div v-if="scope.row.userType == 'primary'">股东</div>
            <div v-if="scope.row.userType == 'partner'">合伙人</div>
          </template>
      </el-table-column>
        <!-- <el-table-column align="center" prop="inviteCode" label="邀请码" width="120">
        </el-table-column> -->
        <el-table-column align="center" label="我的邀请" width="110">
          <template slot-scope="scope">
            <el-button size="mini" @click="onInvit(scope.row)">查看列表</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="setupTime" label="注册时间" width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.setupTime }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="isLock" label="交易密码状态" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.hasPwd">
              <el-button size="mini" type="success" @click="resetpwd(scope.row)">清除密码</el-button>
            </div>
            <div v-if="!scope.row.hasPwd">
              无
            </div>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="是否禁止转出" min-width="120">
          <template slot-scope="scope">
            <el-row v-if="scope.row.disableOut">
              <el-button size="mini" type="success" @click="onDisable(scope.row.disableOut, scope.row)">允许</el-button>
              <span>禁止</span>
            </el-row>
            <el-row v-if="!scope.row.disableOut">
              <span>允许</span>
              <el-button size="mini" type="danger" @click="onDisable(scope.row.disableOut, scope.row)">禁止</el-button>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" label="上级" min-width="110">
          <template slot-scope="scope">
            <el-popover placement="bottom" trigger="click" :content="invitname">
              <el-button size="mini" slot="reference" @click="onUpper(scope.row)">查看上级</el-button>
            </el-popover>
            <!-- <el-button size="mini" @click="onUpper(scope.row)">查看上级</el-button> -->
          </template>
        </el-table-column>
        <el-table-column align="center" label="余额" min-width="110">
          <template slot-scope="scope">
            <el-popover trigger="click">
              <el-table :data="gridData">
                <el-table-column width="120" property="tokenName" label="代币名称">
                  <template slot-scope="scope">
                    <div v-if="scope.row.tokenName == 'Grass'">
                      Grass 可用
                    </div>
                    <div v-if="scope.row.tokenName == 'GLocker'">
                      GLocker 锁仓
                    </div>
                    <div v-if="scope.row.tokenName != 'GLocker' && scope.row.tokenName != 'Grass'">
                      {{ scope.row.tokenName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100" property="balance" label="余额"></el-table-column>
              </el-table>
              <el-button slot="reference" size="mini" @click="onBalances(scope.row)">查看余额</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="用户详情" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="ongetUser(scope.row)">查看用户详情</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="winRate" label="游戏拨出比例" min-width="100">
          <template slot-scope="scope">
            {{ (scope.row.winRate * 100).toFixed(2) + '%' }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column align="center" prop="factor" label="分红系数" min-width="100">
        </el-table-column> -->

      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <div v-else>
      <Invit :code="code" />
    </div>

    <!-- 添加Galex -->
    <el-dialog title="锁仓" :visible.sync="addVisible" width="30%" @click="addVisible = false">
      <el-form label-width="120px" :model="editForm" :rules="Rules" ref="editForm">
        <el-form-item label="用户名" prop="userName">
          <el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input size="small" type="number" v-model="editForm.amount" auto-complete="off"
            onkeyup="this.editForm.amount=this.editForm.amount.replace(/\D|^0/g)" placeholder="请输入金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitUser('editForm')">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="用户详情" :visible.sync="userVisible" width="750px" @click="userVisible = false">
      
      <div v-loading="loadings" class="ulobjDiv">
        <ul v-if="userObj" class="ulobj">
          <li><span>链上 M</span> ：{{ userObj && userObj.chainMBalance }}</li>
          <li><span>锁仓 M</span>：{{ userObj && userObj.lockBalance }}</li>
          <li><span>余额 M</span>：{{ userObj && userObj.mBalance }}</li>
          <li><span>锁仓 L</span>：{{ userObj && userObj.lockLucky }}</li>
          <li><span>质押总数 (包含收益)</span>：{{ userObj && userObj.stakeTotal }}</li>
          <li><span>已到期总数 (包含收益)</span>：{{ userObj && userObj.stakedExpireTotal }}</li>
          <li><span>已领取总数 (包含收益)</span>：{{ userObj && userObj.stakeReceivedTotal }}</li>
          
        </ul>
        <ul v-if="userObj" class="ulobj">
          <li><span>房间游戏 (下总)</span>：{{ userObj && userObj.dxSettle }}</li>
          <li><span>房间游戏 (赢)</span>：{{ userObj && userObj.dxWin }}</li>
          <li><span>房间游戏 (数量比例)</span>：{{ userObj && userObj.dxWinRate && (userObj.dxWinRate * 100 + '%') }}</li>
          <li><span>幸运哈希 (下总)</span>：{{ userObj && userObj.xySettle }}</li>
          <li><span>幸运哈希 (赢)</span>：{{ userObj && userObj.xyWin }}</li>
          <li><span>幸运哈希 (数量比例)</span>：{{ userObj && userObj.xyWinRate && (userObj.xyWinRate * 100 + '%') }}</li>
          <li><span>幸运哈希 (总笔数)</span>：{{ userObj && userObj.xyCount }}</li>
          <li><span>幸运哈希 (赢的笔数)</span>：{{ userObj && userObj.xyWinCount }}</li>
          <li><span>幸运哈希 (笔数比例)</span>：{{ userObj && userObj.xyWinCountRate && (userObj.xyWinCountRate * 100 + '%') }}</li>
        </ul>
      </div>
      
      
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="userVisible = false">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// 导入请求方法
import { RouterLink } from 'vue-router'
import {
  userList,
  userClearPwd,
  disableWithdraw,
  enableWithdraw,
  upper,
  balances,
  AddLocker,
  UserData
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Invit from './Invit'
export default {
  data() {
    return {
      loading: false, //是显示加载
      loadings:false,
      title: '添加用户',
      invitname: '',
      // 请求数据参数
      formInline: {
        from: 1,
        limit: 10,
        userName: '',
      },
      //用户数据
      userData: [],
      gridData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      code: null,
      addVisible: false,
      userVisible:false,
      userObj:null,
      editForm: {
        userName: '',
        amount: 0
      },
      Rules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
      },
    }
  },
  // 注册组件
  components: {
    Pagination,
    RouterLink,
    Invit
  },

  /**
   * 创建完毕
   */
  created() {
    console.log(this.$route.query)
    if (this.$route.query.code) {
      this.code = this.$route.query.code
    } else {
      this.getdata(this.formInline)
    }

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      userList(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.userData = res.data.list
          // 分页赋值
          // this.pageparm.currentPage = this.formInline.from
          // this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.data.total
        }
      })
    },
    ongetUser(row) {
      this.userVisible = true
      this.loadings = true
      // 获取用户列表
      UserData({uid:row.uId,userName:row.userName}).then(res => {
        console.log(res)
        this.loadings = false
        if (res.code != 0) {
          this.userVisible = false
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.userObj = res.data
        }
          
      })
    },
    
    // 分页插件事件
    callFather(parm) {
      console.log(parm)
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage - 1) * (this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      this.getdata(this.formInline)
    },
    //清除用户交易密码
    resetpwd(row) {
      console.log(row.uId)
      userClearPwd({ uId: row.uId }).then(res => {
        this.loading = false
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '清除密码成功'
          })
          this.getdata(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })
        }
      }).catch(err => {
        this.$message.error('清除密码失败')
      })
    },
    // 点击邀请列表
    onInvit(row) {
      this.$router.push({ path: '/user/list?code=' + row.uId })
    },
    onUpper(row) {
      this.invitname = '';
      upper({ uId: row.uId }).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.invitname = res.data.inviter
        }
      })
    },
    onBalances(row) {
      this.gridData = [];
      balances({ uId: row.uId }).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.gridData = res.data.list
        }
      })
    },

    onDisable(falg, row) {
      if (falg) {
        this.$confirm('是否允许转出', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          enableWithdraw({ uId: row.uId }).then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.$message({
                type: 'success',
                message: '成功允许转出!'
              });
              this.getdata(this.formInline)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      } else {
        this.$confirm('是否禁止转出', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          disableWithdraw({ uId: row.uId }).then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.$message({
                type: 'success',
                message: '成功禁止转出!'
              });
              this.getdata(this.formInline)
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });

      }
    },

    submitUser(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading = true
          this.editForm.amount = parseFloat(this.editForm.amount)
          AddLocker(this.editForm).then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.$message({
                type: 'success',
                message: '锁仓成功!'
              });
              this.addVisible = false
            }
          })
        }
      })

    },
  },
  watch: {
    // 监听路由是否变化
    '$route'(to, from) {
      if (to.query.code) {
        if (to.query.code != from.query.code) {
          // alert(to.query.code)
          this.code = to.query.code
        }
      } else {
        this.code = null;
        this.formInline.from = 1
        this.getdata(this.formInline)
      }
    }
  },
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
.ulobj{
  list-style: none;
  padding: 0;
  margin: 0;
  width: 50%;
}
.ulobjDiv{
  display: flex;
}
.ulobj li{
  margin-bottom: 10px;
}
.ulobj li span{display: inline-block;width: 150px;text-align: left;padding-right: 0px;}
</style>

 


// WEBPACK FOOTER //
// src/views/system/user.vue